export default __webpack_public_path__ + "static/media/uploader-abbottLite-2.7e13a70c.png";